import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách menu giới thiệu theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách các mục menu giới thiệu
 */
export const getIntroduceMenusByLanguage = async (languageCode) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.INTRODUCE_MENUS.GET_BY_LANGUAGE(languageCode)
    );
    const data = response.data;

    if (data && data.success && Array.isArray(data.data)) {
        return data.data;
    }

    return [];
};
